/* control.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"];
import "./control.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { components } from '@atlaskit/select';
import { N40 } from '@atlaskit/theme/colors';
import { withFeatureFlaggedComponent } from '../../../../common/utils/withFeatureFlaggedComponent';
var popupCustomControlStylesOld = function popupCustomControlStylesOld() {
  return {
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    border: 'none',
    borderBottom: "solid 1px ".concat("var(--ds-border, ".concat(N40, ")")),
    minHeight: 'auto'
  };
};
var popupCustomControlStyles = function popupCustomControlStyles() {
  return {
    display: 'flex',
    borderRadius: '3px',
    border: "solid 1px ".concat("var(--ds-border-input, #8C8F97)")
  };
};
var popupCustomControlVisualRefreshStyles = {
  container: "_ca0q1b66 _n3td1b66 _19bvh9hh _u5f3h9hh"
};
export var CustomControlOld = function CustomControlOld(_ref) {
  var children = _ref.children,
    innerProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(components.Control, _extends({}, innerProps, {
    getStyles: popupCustomControlStylesOld
  }), children);
};
export var CustomControl = function CustomControl(_ref2) {
  var children = _ref2.children,
    innerProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: popupCustomControlVisualRefreshStyles.container
  }, /*#__PURE__*/React.createElement(components.Control, _extends({}, innerProps, {
    getStyles: popupCustomControlStyles
  }), children));
};
export default withFeatureFlaggedComponent(CustomControlOld, CustomControl, function () {
  return fg('platform-linking-visual-refresh-sllv');
});